<template>
    <div class="contact-list">
        <div>
            <div style="padding: 5px;position: absolute;top: 50px;width: 260px;">
                <el-input
                    placeholder="请输入搜索关键字"
                    prefix-icon="el-icon-search"
                    @keyup.native.enter="searchUsersByCondition"
                    v-model="keyword"
                ></el-input>
            </div>
            <el-tree
                class="contact-list-tree"
                :data="treeData"
                :props="defaultProps"
                :lazy="true"
                :load="loadNode"
                :expand-on-click-node="false"
                node-key="id"
                :default-expanded-keys="defaultExpandedKeys"
            >
                <div
                    slot-scope="{ node, data }"
                    style="width: 100%;height:100%;"
                    @click="nodeClickHandler(data, node)"
                >
                    <img :src="require('@/assets/img/org/department.png')" align="center" />
                    {{ data.Name }}
                </div>
            </el-tree>
        </div>
        <div class="table-wrapper">
            <el-row
                type="flex"
                justify="space-between"
                style="background:#F4F4F4;position: absolute;top:0;left:0;right:0;"
            >
                <el-col>
                    <div
                        style="margin-left: 30px;font-weight:400;font-size: 17px;color: #000000;height: 42px;line-height: 42px;"
                    >{{ title }}</div>
                </el-col>
                <el-col align="right">
                    <div style="margin-right: 30px;height: 42px;line-height: 42px;">
                        <!-- <el-button type="primary">添加成员</el-button> -->
                    </div>
                </el-col>
            </el-row>
            <div class="table-div">
                <el-table
                    :data="tableData"
                    :stripe="true"
                    height="100%"
                    style="width:100%;"
                    :header-row-style="{
                        color: 'rgba(144, 147, 153, 1)',
                        'font-weight': 'bold',
                        'font-size': '12px',
                    }"
                    :row-style="{
                        height: '42px'
                    }"
                    :cell-style="{
                        height: '42px',
                        'font-size': '12px',
                        color: 'rgba(1,1,1,1)'
                    }"
                >
                    <el-table-column label="序号" width="100">
                        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                    </el-table-column>
                    <el-table-column label="员工名称" prop="Name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="员工工号" prop="EmployeeNumber" show-overflow-tooltip></el-table-column>
                    <el-table-column label="固定电话" prop="OfficePhone"></el-table-column>
                    <el-table-column label="手机号码" prop="Mobile"></el-table-column>
                    <el-table-column label="电子邮箱" prop="Email" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <el-row style="background:#F4F4F4;position: absolute;bottom:0;left:0;right:0;">
                <el-col align="right" style="margin: 10px 0 10px 0;">
                    <el-pagination
                        background
                        :current-page="PagingInfo.PageIndex"
                        :total="PagingInfo.DataCount"
                        :page-size="PagingInfo.PageSize"
                        :page-count="PagingInfo.PageCount"
                        @current-change="PageIndexChange"
                    ></el-pagination>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import DeptService from '@/services/dept.service';
import LoginService from '@/services/login.service';

/*
dept: {
    Name,
    ID,
    UnitType,
}
*/

export default {
    name: 'contact-list',
    props: {
        dept: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            title: '',
            currentObjectID: '',
            keyword: '',
            LoginService,
            treeData: [],
            tableData: [],
            defaultProps: {
                label: 'Name',
            },
            PagingInfo: {
                PageIndex: 1,
                PageSize: 10,
                DataCount: 0,
                PageCount: 10,
            },
            defaultExpandedKeys: [],
        };
    },

    methods: {
        setPagingInfo(pageInfo) {
            this.PagingInfo.PageSize = pageInfo.PageSize;
            this.PagingInfo.DataCount = pageInfo.DataCount;
            this.PagingInfo.PageCount = pageInfo.PageCount;
        },
        searchUsersByCondition() {
            if (this.keyword.trim() === '') {
                this.title = LoginService.userInfo.CompanyName;
                this.getUsersByCondition(this.dept.ObjectID || LoginService.userInfo.CompanyID);
            } else {
                const SearchCondition = {
                    Name: 'SearchKey',
                    Operation: 'Contain',
                    QueryType: 1,
                    Value: this.keyword,
                    ValueType: 0,
                };
                this.PagingInfo.PageIndex = 1;
                DeptService.GetChildUsersWithAcl(
                    this.dept.ObjectID,
                    {
                        PagingInfo: {
                            PageIndex: this.PagingInfo.PageIndex,
                            PageSize: this.PagingInfo.PageSize,
                        },
                        SearchCondition: [SearchCondition],
                        FilterRole: false,
                    },
                    'Active',
                    true
                ).then(res => {
                    if (res.Success) {
                        this.tableData = res.Result.Datas;
                        this.setPagingInfo(res.Result.PagingInfo);
                    }
                });
            }
        },
        /**
         * AclId 过滤条件
         * unitId 要取数据的部门ID
         */
        getChildDeptAndGroupWithAcl(AclId, unitId) {
            return new Promise((resolve, reject) => {
                DeptService.getChildDeptAndGroupWithAcl(AclId, unitId).then(r => {
                    if (r.Success) {
                        resolve(r.Result);
                    } else {
                        reject([]);
                    }
                });
            });
        },
        getUsersByCondition(keyword, FilterRole = false, State = 'Active') {
            const SearchCondition = {
                Name: 'ParentID',
                Operation: 'Equal',
                QueryType: 1,
                Value: keyword,
                ValueType: 0,
            };
            DeptService.getUsersByCondition(
                this.PagingInfo,
                [SearchCondition],
                FilterRole,
                State,
                true
            ).then(res => {
                if (res.Success) {
                    this.tableData = res.Result.Datas;
                    this.setPagingInfo(res.Result.PagingInfo);
                }
            });
        },
        loadNode(node, resolve) {
            if (node.level === 0) {
                let temp = {
                    ObjectID: LoginService.userInfo.CompanyID,
                    Name: LoginService.userInfo.CompanyName,
                    UnitType: LoginService.userInfo.UnitType,
                    children: [],
                };

                this.getChildDeptAndGroupWithAcl(
                    this.dept.ObjectID || LoginService.userInfo.CompanyID,
                    LoginService.userInfo.CompanyID
                ).then(r => {
                    temp.children.push(r);
                    resolve([temp]);
                    setTimeout(() => {
                        document
                            .querySelector(
                                '.contact-list-tree .el-tree-node__expand-icon.el-icon-caret-right'
                            )
                            .click();
                    }, 100);
                });

                this.reloadUserList({
                    ObjectID: this.dept.ObjectID || LoginService.userInfo.CompanyID,
                    Name: LoginService.userInfo.CompanyName,
                });
            } else if (node.level === 1) {
                if (node.data) {
                    this.getChildDeptAndGroupWithAcl(
                        this.dept.ObjectID || LoginService.userInfo.CompanyID,
                        node.data.ObjectID
                    ).then(r => {
                        resolve(r);
                    });
                } else {
                    resolve([]);
                }
            } else {
                if (node.data) {
                    this.getChildDeptAndGroupWithAcl(
                        this.dept.ObjectID || LoginService.userInfo.CompanyID,
                        node.data.ObjectID
                    ).then(r => {
                        resolve(r);
                    });
                } else {
                    resolve([]);
                }
            }
        },
        nodeClickHandler(data, node) {
            if (node.level < 2 || this.title === data.Name) {
                return;
            }
            this.reloadUserList(data);
        },
        reloadUserList(data) {
            this.PagingInfo.PageIndex = 1;
            this.title = data.Name;
            this.currentObjectID = data.ObjectID;
            this.getUsersByCondition(data.ObjectID);
        },
        PageIndexChange(page) {
            this.PagingInfo.PageIndex = page;
            this.getUsersByCondition(this.currentObjectID);
        },
    },
};
</script>

<style lang="scss">
.contact-list {
    @import '@/assets/style/main.scss';
    display: flex;
    flex-direction: row;
    height: 100%;
    &-tree {
        width: 272px;
        overflow-y: scroll;
        position: absolute;
        left: 10px;
        top: 88px;
        bottom: 10px;
        padding: 10px;
        .el-tree-node__content {
            height: $tree-node-height;
            line-height: $tree-node-height;
        }
    }
    .table-wrapper {
        position: absolute;
        left: 300px;
        right: 10px;
        top: 50px;
        bottom: 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
        // position: relative;
        .table-div {
            flex: 1;
            position: absolute;
            top: 42px;
            left: 0;
            right: 0;
            bottom: 52px;
        }
    }
}
</style>